import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { refundOrder } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useRefundOrder = () => {
    const queryClient = useQueryClient();

    const { mutate: refundOrderMutate, isPending: isRefunding } = useMutation({
        mutationFn: ({ id, data }) => refundOrder(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Refund processed successfully");
            queryClient.invalidateQueries(["orders"]);
            queryClient.invalidateQueries(["order"]);
            queryClient.invalidateQueries(["order-timeline"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to process refund");
        },
    });

    return { refundOrderMutate, isRefunding };
};
